/* eslint-disable no-alert */
import Vue from 'vue'

const alert = {
  confirm: (text) => {
    const answer = window.confirm(text)
    return answer
  }
}

Vue.prototype.$alert = alert

export default alert
